import React from 'react';
import './PracticeScrimmageStats.css';

const ScrimmageStatsSummarySection = ({ scrimmageStats, compact = false }) => {
  if (!scrimmageStats) return null;

  const goals = [...(scrimmageStats.goals || [])].sort(
    (a, b) => (a.minute ?? 0) - (b.minute ?? 0)
  );
  const playerStats = [...(scrimmageStats.playerStats || [])]
    .filter((p) => p.goals + p.assists + p.saves + p.defended > 0)
    .sort((a, b) => {
      const scoreA = a.goals * 10 + a.assists * 5 + a.saves + a.defended;
      const scoreB = b.goals * 10 + b.assists * 5 + b.saves + b.defended;
      return scoreB - scoreA || (a.playerName || '').localeCompare(b.playerName || '');
    });

  return (
    <section className={`scrimmage-section card${compact ? ' scrimmage-section--compact' : ''}`}>
      <h2>Scrimmage stats</h2>
      <div className="scrimmage-scoreboard scrimmage-scoreboard--public">
        <div className="scrimmage-scoreboard__team scrimmage-scoreboard__team--red">
          <span>🔴 Red</span>
          <strong>{scrimmageStats.scoreRed ?? 0}</strong>
        </div>
        <span>–</span>
        <div className="scrimmage-scoreboard__team scrimmage-scoreboard__team--blue">
          <span>🔵 Blue</span>
          <strong>{scrimmageStats.scoreBlue ?? 0}</strong>
        </div>
      </div>

      {goals.length > 0 && (
        <>
          <h3 className="scrimmage-section__subheading">Goals</h3>
          <ul className="scrimmage-goals-list">
            {goals.map((g) => (
              <li key={g.id} className="scrimmage-goal-item scrimmage-goal-item--readonly">
                <span className="scrimmage-goal-item__minute">{g.minute}&apos;</span>
                <span>{g.teamSide === 'RED' ? '🔴' : '🔵'}</span>
                <span>
                  <strong>{g.scorerPlayerName}</strong>
                  {g.assistPlayerName && ` (assist: ${g.assistPlayerName})`}
                </span>
              </li>
            ))}
          </ul>
        </>
      )}

      {playerStats.length > 0 && (
        <>
          <h3 className="scrimmage-section__subheading">Player highlights</h3>
          <div className="scrimmage-stats-table">
            <div className="scrimmage-stats-table__head">
              <span>Player</span>
              <span>G</span>
              <span>A</span>
              <span>SV</span>
              <span>Def</span>
            </div>
            {playerStats.map((p) => (
              <div key={p.playerId} className="scrimmage-stats-table__row">
                <span>{p.playerName}</span>
                <span>{p.goals || '—'}</span>
                <span>{p.assists || '—'}</span>
                <span>{p.saves || '—'}</span>
                <span>{p.defended || '—'}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </section>
  );
};

export default ScrimmageStatsSummarySection;
